var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFind = function SvgFind(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 19.42L14.7793 15.7728L18.42 19.42ZM16.7968 10.8984C16.7968 12.728 16.07 14.4826 14.7763 15.7763C13.4826 17.07 11.728 17.7968 9.89842 17.7968C8.06885 17.7968 6.31421 17.07 5.0205 15.7763C3.7268 14.4826 3 12.728 3 10.8984C3 9.06885 3.7268 7.31421 5.0205 6.0205C6.31421 4.7268 8.06885 4 9.89842 4C11.728 4 13.4826 4.7268 14.7763 6.0205C16.07 7.31421 16.7968 9.06885 16.7968 10.8984V10.8984Z",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFind, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/find.65d8548b.svg";
export { ForwardRef as ReactComponent };